import { MediaService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import { settleWithin } from '@helpers/settleWithin';
import type { TCall } from 'app/queries/types/TCall';

export const MEDIA_ANALYSIS_LEGACY_LOOKUP_TIMEOUT_MS = 10000;

export const fetchLegacyAnalysisJob = async (call: TCall, mediaId: string, signal: AbortSignal) => {
  if (signal.aborted) {
    return undefined;
  }
  const lookupController = new AbortController();
  const abortLookup = () => lookupController.abort();
  signal.addEventListener('abort', abortLookup, { once: true });
  try {
    return await settleWithin(
      call(() => cancelOnSignal(MediaService.getAnalysisStatus({ mediaId }), lookupController.signal), {
        dontRedirectOnError: true,
      }),
      MEDIA_ANALYSIS_LEGACY_LOOKUP_TIMEOUT_MS,
    );
  } finally {
    signal.removeEventListener('abort', abortLookup);
    lookupController.abort();
  }
};
